module.exports = __webpack_public_path__ + "static/media/bordered-tick.732a5eef.svg";